import Vue, { computed } from 'vue'
import VueRouter from 'vue-router'
import pinia from '@/plugins'
import { useUserStore } from '@/store/app'
import useAuthentication from '@/hooks/useAuthentication'

const isLocalDev = import.meta.env.MODE === 'development'
console.log('isLocalDev:', isLocalDev)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const files = import.meta.glob('./*.js', { eager: true })
const routeArr = []
for (const path in files) {
  if (path !== './index.js') {
    const mod = files[path]
    const routes = mod.default

    if (Array.isArray(routes)) {
      routeArr.push(...routes)
    } else if (routes) {
      routeArr.push(routes)
    }
  }
}

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    authed: 'DASHBOARD',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      tabName: 'Operation Figure',
      group: 'Operation Figure',
      icon: 'mdiHomeOutline',
    },
  },

  ...routeArr, // 各个模块的路由

  {
    path: '/error-401',
    name: 'error-401',
    component: () =>
      isLocalDev ? import('@/views/LoginPage.vue') : import('@/views/401.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    name: 'error-403',
    path: '/error-403',
    component: () =>
      isLocalDev ? import('@/views/LoginPage.vue') : import('@/views/403.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/404.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.VITE_APP_BASE_URL,
  routes,
})

const allRouteList = routes
  .filter((routerItem) => routerItem.name)
  .map((item) => item.name)

router.beforeEach(async (to, from, next) => {
  // 获取权限信息

  await useAuthentication(routes)

  const store = useUserStore(pinia)
  const loadStatus = computed(() => store.loadStatus)

  const permissionList = computed(() => store.menuPermissionNames)

  if (loadStatus.value === 'EXPIRES' && to.name !== 'error-401') {
    next('/error-401')
  } else if (loadStatus.value === 'FAILED' && to.name !== 'error-403') {
    next('/error-403')
  } else if (loadStatus.value === 'SUCCEEDED') {
    if (allRouteList.includes(to.name)) {
      if (permissionList.value.includes(to.name)) {
        next()
      } else {
        next('/error-403')
      }
    } else {
      next('/error-404')
    }
  } else {
    next()
  }
})

export default router
